import { Toast } from 'vant';

export default {
    inserted: (el, binding) => {
        if (binding.value) {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0, // 持续显示
            });
        } else {
            Toast.clear(); // 清除加载状态
        }
    }
};
